export default __webpack_public_path__ + "static/media/contact-background-mobile@1x.19833745.jpg";